import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

/** A viewer preference: never sent to other players or tied to cosmetic ownership. */
object DiceDisplayPreferences {
    private val twoDimensionalState = MutableStateFlow(false)
    val twoDimensional = twoDimensionalState.asStateFlow()

    fun restore(preferences: PlayerPreferences) {
        twoDimensionalState.value = preferences.getDice2DMode()
    }

    fun setTwoDimensional(enabled: Boolean, preferences: PlayerPreferences) {
        preferences.setDice2DMode(enabled)
        twoDimensionalState.value = enabled
    }
}

/** Whether seasonal decoration (start-screen leaves and bats, in-game event effects) is shown. */
object SeasonalEffectsPreferences {
    // Off until App() restores the saved choice (which defaults to on) at startup, so screens
    // rendered without the app shell (UI tests) never start the endless seasonal animations.
    private val enabledState = MutableStateFlow(false)
    val enabled = enabledState.asStateFlow()

    fun restore(preferences: PlayerPreferences) {
        enabledState.value = preferences.getSeasonalEffectsEnabled()
    }

    fun setEnabled(enabled: Boolean, preferences: PlayerPreferences) {
        preferences.setSeasonalEffectsEnabled(enabled)
        enabledState.value = enabled
    }
}
